export default "__VITE_ASSET__7e91947e__"